import Autocomplete from '@mui/material/Autocomplete';
import { FormHelperText, TextField } from '@mui/material';
import { useMemo, useState } from 'react';
import { useFetch } from '../hooks/useFecth';

export default function SelectOffer({ value, name, onChange, placeholder, label }) {
    const [search, setSearch] = useState('');
    const { data, error, isFetching } = useFetch('offer', {
        params: {
            status: true,
            per_page: 50,
            ...(search.trim() ? { name: search.trim() } : {}),
        },
    });

    const options = useMemo(() => {
        const rows = data?.rows || [];
        return rows.map(item => ({
            id: item.id,
            label: item.Advertiser?.name ? `${item.name} · ${item.Advertiser.name}` : item.name || `Oferta #${item.id}`,
        }));
    }, [data]);

    const selected =
        options.find(item => String(item.id) === String(value)) ||
        (value ? { id: value, label: `Oferta #${value}` } : null);

    return (
        <>
            <Autocomplete
                fullWidth
                options={options}
                value={selected}
                loading={isFetching}
                getOptionLabel={option => option?.label || ''}
                isOptionEqualToValue={(option, optionValue) => String(option?.id) === String(optionValue?.id)}
                onChange={(_, newValue) => onChange(name, newValue?.id != null ? String(newValue.id) : '')}
                onInputChange={(_, input, reason) => {
                    if (reason === 'input') setSearch(input);
                }}
                renderInput={params => <TextField {...params} label={placeholder || label || 'Oferta'} />}
            />
            {!!error?.message && <FormHelperText>{error.message}</FormHelperText>}
        </>
    );
}
